
<div *ngIf="getSupportReq() | async" class="enlarged-popup-content content">
  <div *ngIf="supportCenterInfo">
    <tra-md [slug]="supportCenterInfo.text"></tra-md>
    <div style="margin-top:1em;">
      <table class="table is-bordered" data-ui-name="Info center details table" data-ui-component="info-center-details" data-testid="info-center-details-info-center-details-table">
        <tr data-ui-name="Fp email values row" data-ui-component="info-center-details" data-testid="info-center-details-fp-email-values-row">
          <th> <tra slug="lbl_fp_email"></tra> </th>
          <td><a [href]="emailUrl" data-ui-name="Get Email()" data-ui-component="info-center-details" data-testid="info-center-details-get-email">{{getEmail()}}</a></td>
        </tr>
        <tr *ngIf="isPhoneDisplayed()" data-ui-name="Cts location phone lbl values row" data-ui-component="info-center-details" data-testid="info-center-details-cts-location-phone-lbl-values-row">
          <th><tra slug="cts_location_phone_lbl"></tra></th>
          <td><tra-md [slug]="supportCenterInfo.phone"></tra-md></td>
        </tr>
      </table>
    </div>
  </div>
  <div style="margin-top:1em;">
    <button (click)="dismiss.emit()" class="button is-warning" data-ui-name="Dismiss notif" data-ui-component="info-center-details" data-testid="info-center-details-dismiss-notif">
      <tra slug="btn_dismiss_notif"></tra>
    </button>
  </div>
</div>
    
      